/* EO DEV - isolated cart quote. Does not touch Shopify Ajax cart or checkout. */
(() => {
  if (window.__eoIsolatedShippingLoaded) return;
  window.__eoIsolatedShippingLoaded = true;
  const API = '2026-10';
  const CREATE = `mutation($input:CartInput!){cartCreate(input:$input){cart{id}userErrors{message}}}`;
  const QUOTE = `query($id:ID!){cart(id:$id){id ... @defer {deliveryGroups(first:10,withCarrierRates:true){nodes{deliveryOptions{title description estimatedCost{amount currencyCode}}}}}}}`;
  const safe = value => String(value ?? '').replace(/[&<>"']/g, x => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[x]));
  async function graphql(el, query, variables) {
    const response = await fetch('https://'+el.dataset.shopDomain+'/api/'+API+'/graphql.json', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/graphql-response+json, multipart/mixed, application/json','X-Shopify-Storefront-Access-Token':el.dataset.publicToken},
      body:JSON.stringify({query,variables})
    });
    if(!response.ok) throw Error('Falha ao consultar as opções de entrega.');
    const raw = await response.text();
    const parts = [];
    if(response.headers.get('content-type')?.includes('multipart/mixed')){
      const boundary = response.headers.get('content-type').match(/boundary="?([^";]+)"?/i)?.[1];
      if(boundary) for(const section of raw.split('--'+boundary)){
        const match=section.match(/\r?\n\r?\n([\s\S]*)/);
        if(match){try{parts.push(JSON.parse(match[1].trim()));}catch(_){}}
      }
    } else {try{parts.push(JSON.parse(raw))}catch(_){}}
    if(!parts.length) throw Error('Resposta de frete não disponível.');
    const errors=parts.flatMap(p => p.errors || []);
    if(errors.length) throw Error(errors[0].message || 'Não foi possível calcular.');
    return parts;
  }
  async function address(zip){
    for(const url of ['https://brasilapi.com.br/api/cep/v1/'+zip,'https://viacep.com.br/ws/'+zip+'/json/']){
      try{
        const response=await fetch(url,{headers:{Accept:'application/json'}});
        if(!response.ok)continue;
        const data=await response.json();
        if(data.erro)continue;
        const uf=data.state||data.uf;
        if(uf)return {uf,city:data.city||data.localidade||'',street:data.street||data.logradouro||'',district:data.neighborhood||data.bairro||''};
      }catch(_){}
    }
    throw Error('Não foi possível identificar o endereço deste CEP.');
  }
  function options(parts){
    const opts=[];
    function visit(obj){
      if(!obj || typeof obj!=='object')return;
      if(Array.isArray(obj)){obj.forEach(visit);return}
      if(Array.isArray(obj.deliveryOptions))opts.push(...obj.deliveryOptions);
      Object.entries(obj).filter(([k])=>k!=='deliveryOptions').forEach(([,v])=>visit(v));
    }
    parts.forEach(visit);
    return [...new Map(opts.filter(x=>x?.estimatedCost?.amount!=null).map(x=>[x.title+'|'+x.estimatedCost.amount,x])).values()];
  }
  document.addEventListener('submit',async event=>{
    const form=event.target.closest('[data-eo-quote-form]');
    if(!form)return;
    event.preventDefault();
    const el=form.closest('[data-eo-isolated-shipping]');
    const result=el.querySelector('[data-eo-quote-result]');
    const label=el.querySelector('[data-eo-quote-address]');
    const button=form.querySelector('button[type="submit"]');
    const zip=(form.querySelector('[name="cep"]')?.value||'').replace(/\D/g,'');
    if(zip.length!==8){result.textContent='Informe um CEP de oito números.';return}
    const original=button.textContent;
    button.disabled=true;button.textContent='CALCULANDO…';result.textContent='Consultando tarifas…';label.textContent='';
    try{
      const addr=await address(zip);
      label.textContent=[addr.street,addr.district,addr.city,addr.uf].filter(Boolean).join(' · ');
      const selected=document.querySelector('form[action*="/cart/add"] [name="id"]');
      const id=selected?.value||el.dataset.variantGid.split('/').pop();
      const qtyInput=document.querySelector('form[action*="/cart/add"] [name="quantity"]');
      const quantity=Math.max(1,Math.min(50,parseInt(qtyInput?.value||el.dataset.quantity,10)||1));
      const input={lines:[{merchandiseId:'gid://shopify/ProductVariant/'+id,quantity}],buyerIdentity:{countryCode:'BR'},delivery:{addresses:[{selected:true,address:{deliveryAddress:{zip,countryCode:'BR',provinceCode:addr.uf,city:addr.city,address1:addr.street||'Endereço não informado'}}}]}};
      const created=await graphql(el,CREATE,{input});
      const payload=created[0]?.data?.cartCreate;
      if(!payload?.cart?.id)throw Error(payload?.userErrors?.[0]?.message||'Não foi possível preparar a cotação.');
      const quotes=await graphql(el,QUOTE,{id:payload.cart.id});
      const rates=options(quotes);
      if(!rates.length){result.textContent='Sem tarifas disponíveis nesta consulta. Confira as opções finais no checkout.';return}
      result.innerHTML='<div class="eo-cep-estimator__rates">'+rates.map(rate=>{
        const currency=rate.estimatedCost.currencyCode||'BRL';
        const price=Number(rate.estimatedCost.amount);
        return '<div class="eo-quote-rate"><div class="eo-quote-rate__copy"><span class="eo-quote-rate__name">'+safe(rate.title)+'</span>'+(rate.description?'<span class="eo-quote-rate__description">'+safe(rate.description)+'</span>':'')+'</div><strong class="eo-quote-rate__price">'+new Intl.NumberFormat('pt-BR',{style:'currency',currency}).format(price)+'</strong></div>';
      }).join('')+'</div>';
    }catch(error){result.textContent=error.message||'Não foi possível calcular o frete.'}
    finally{button.disabled=false;button.textContent=original}
  });
})();
